module.exports = __webpack_public_path__ + "assets/img/shopify-store.4d3dcec8.png";